let csrfToken: string | null = null;
export async function api(
  path: string,
  method = 'GET',
  body?: unknown,
  retrySession = true,
): Promise<any> {
  const response = await fetch(`/api/v1${path}`, {
    method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(method !== 'GET' ? { 'X-Requested-With': 'CRM' } : {}),
      ...(method !== 'GET' && csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  let result: any;
  try {
    result = response.status === 204 ? {} : await response.json();
  } catch {
    if (response.ok)
      throw Object.assign(
        new Error('The server returned an invalid response. Refresh the workspace and try again.'),
        { code: 'INVALID_RESPONSE', status: response.status },
      );
    result = {};
  }
  if (result === null || typeof result !== 'object') {
    if (response.ok)
      throw Object.assign(
        new Error('The server returned an invalid response. Refresh the workspace and try again.'),
        { code: 'INVALID_RESPONSE', status: response.status },
      );
    result = {};
  }
  if (response.ok && 'csrfToken' in result) csrfToken = result.csrfToken;
  if (response.ok && path === '/auth/logout') csrfToken = null;
  if (response.status === 401 && path !== '/bootstrap' && retrySession) {
    const session = await fetch('/api/v1/bootstrap', { credentials: 'include' });
    const state = await session.json().catch(() => ({}));
    if (session.ok && state?.demo === true) {
      if (typeof state.csrfToken === 'string') csrfToken = state.csrfToken;
      return api(path, method, body, false);
    }
  }
  if (!response.ok) {
    if (
      !path.startsWith('/auth/') &&
      (response.status === 401 || result.error?.code === 'PASSWORD_CHANGE_REQUIRED')
    )
      window.dispatchEvent(new Event('crm:session-expired'));
    throw Object.assign(
      new Error(result.error?.message || result.message || `Request failed (${response.status})`),
      { details: result.error?.details, code: result.error?.code, status: response.status },
    );
  }
  return result;
}
export const money = (v: number = 0, compact = true) =>
  compact
    ? v >= 10000000
      ? `₹${Number((v / 10000000).toFixed(2))} Cr`
      : v >= 100000
        ? `₹${Number((v / 100000).toFixed(1))} L`
        : `₹${v.toLocaleString('en-IN')}`
    : new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
      }).format(v);
export const initials = (name: string = '') =>
  name
    .split(' ')
    .map((s) => s[0])
    .slice(0, 2)
    .join('');
export const dateLabel = (date: string) =>
  date
    ? new Date(date).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        timeZone: 'Asia/Kolkata',
      })
    : 'Not scheduled';
export const today = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(new Date());
